module.exports = __webpack_public_path__ + "img/map_15.112b1121.png";